'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VXSpotlightFields = undefined;

var _map = require('ramda/src/map');

var _map2 = _interopRequireDefault(_map);

var _values = require('ramda/src/values');

var _values2 = _interopRequireDefault(_values);

var _pipe = require('ramda/src/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _core = require('@blueprintjs/core');

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = _glamorous2.default.div({
  padding: 10
}, function (_ref) {
  var isRtl = _ref.isRtl;
  return {
    direction: isRtl ? 'rtl' : 'ltr',
    '& span': {
      marginRight: isRtl ? '7px' : null
    }
  };
});

var VXSpotlightFields = exports.VXSpotlightFields = function VXSpotlightFields(_ref2) {
  var fields = _ref2.fields,
      onChangeField = _ref2.onChangeField,
      FieldLabelRenderer = _ref2.FieldLabelRenderer,
      isRtl = _ref2.isRtl;
  return _react2.default.createElement(_core.Popover, {
    position: _core.Position.BOTTOM,
    target: _react2.default.createElement(_core.Button, { className: (0, _classnames2.default)(_core.Classes.MINIMAL), iconName: 'filter-list' }),
    content: _react2.default.createElement(
      Wrapper,
      {
        className: (0, _classnames2.default)(_core.Classes.BUTTON_GROUP, _core.Classes.MINIMAL, _core.Classes.VERTICAL, _core.Classes.ALIGN_LEFT),
        isRtl: isRtl
      },
      (0, _pipe2.default)(_values2.default, (0, _map2.default)(function (field) {
        return _react2.default.createElement(
          _core.Button,
          {
            key: field.id,
            className: (0, _classnames2.default)(_core.Classes.MINIMAL),
            onClick: onChangeField(field),
            iconName: field.isSelected ? 'tick' : isRtl ? null : 'blank'
          },
          _react2.default.createElement(FieldLabelRenderer, { id: field.id })
        );
      }))(fields)
    )
  });
};

VXSpotlightFields.propTypes = {
  fields: _propTypes2.default.objectOf(_propTypes2.default.shape({
    id: _propTypes2.default.string,
    isSelected: _propTypes2.default.bool
  })),
  onChangeField: _propTypes2.default.func.isRequired,
  FieldLabelRenderer: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool
};

VXSpotlightFields.defaultProps = {
  fields: {}
};


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/vx-spotlight/vx-spotlight-fields.js
// module id = 2039
// module chunks = 0